var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable max-len */
import React from "react";
import styled from "styled-components";
import BaseSvgIcon from "./Base";
var Sort = function (props) {
    return (React.createElement(BaseSvgIcon, __assign({ viewBox: "0 0 20.33 15.1" }, props),
        React.createElement("g", { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" },
            React.createElement("g", { id: "Sort", stroke: "#3D3D35", strokeWidth: "1.3" },
                React.createElement("polyline", { id: "Path", points: "0.65 3 3 0.65 5.3 2.96" }),
                React.createElement("polyline", { id: "Path", points: "5.3 12.1 2.96 14.45 0.65 12.14" }),
                React.createElement("path", { d: "M8.86,1.62 L19.54,1.62", id: "Path" }),
                React.createElement("path", { d: "M8.86,5.5 L17.19,5.5", id: "Path" }),
                React.createElement("path", { d: "M8.86,13.28 L16.26,13.28", id: "Path" }),
                React.createElement("path", { d: "M8.86,9.39 L19.68,9.39", id: "Path" }),
                React.createElement("path", { d: "M2.98,14.45 L2.98,0.65", id: "Path" })))));
};
export default styled(Sort)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;
